import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="flex items-center gap-1">
      <button
        onClick={() => changeLanguage('en')}
        className={`px-3 py-1.5 text-sm font-medium transition-all duration-200 ${
          i18n.language === 'en'
            ? 'text-[#FFD600]'
            : 'text-white/70 hover:text-white'
        }`}
        aria-label="Switch to English"
      >
        EN
      </button>
      <span className="text-white/50">|</span>
      <button
        onClick={() => changeLanguage('fr')}
        className={`px-3 py-1.5 text-sm font-medium transition-all duration-200 ${
          i18n.language === 'fr'
            ? 'text-[#FFD600]'
            : 'text-white/70 hover:text-white'
        }`}
        aria-label="Passer au français"
      >
        FR
      </button>
    </div>
  );
};

export default LanguageSwitcher;
